/**
 * Reducers specify how the application's state changes in response to actions sent to the store.
 *
 * @see https://redux.js.org/basics/reducers
 */

import { createReducer } from 'reduxsauce';
import { PickingCriteriaList01Types } from './Actions';
import INITIAL_STATE from './InitialState';

export const pickingCriteriaList01ResetTimestamp = (
  state,
  { currentPage, sorts, filters, pageSize }
) => ({
  ...state,
  currentPage: currentPage || state.currentPage,
  sorts: sorts || state.sorts,
  filters: filters || state.filters,
  pageSize: pageSize || state.pageSize,
  timestamp: Date.now()
  // selectedDocuments: INITIAL_STATE.selectedDocuments
});

export const pickingCriteriaList01FetchPickingCriteriaList01Loading = (state, { boolean }) => ({
  ...state,
  fetchIsLoading: boolean
});

export const pickingCriteriaList01FetchPickingCriteriaList01Success = (
  state,
  { documents, currentPage, lastPage, total, pageSize }
) => ({
  ...state,
  documents,
  currentPage,
  lastPage,
  total,
  pageSize
});

export const pickingCriteriaList01AddSelectedDocuments = (state, { selectedDocuments }) => {
  const selectIds = state.selectedDocuments.map(value => value.id);
  return {
    ...state,
    selectedDocuments: [
      ...state.selectedDocuments,
      ...selectedDocuments.filter(data => {
        return !selectIds.includes(data.id);
      })
    ]
  };
};

export const pickingCriteriaList01RemoveSelectedDocuments = (state, { selectedDocuments }) => {
  const selectIds = selectedDocuments.map(value => value.id);
  return {
    ...state,
    selectedDocuments: state.selectedDocuments.filter(data => {
      return !selectIds.includes(data.id);
    })
  };
};

export const pickingCriteriaList01SetWorkspaceVisible = (state, { boolean }) => ({
  ...state,
  workspaceIsVisible: boolean
});

/**
 * @see https://github.com/infinitered/reduxsauce#createreducer
 */
export const reducer = createReducer(INITIAL_STATE, {
  [PickingCriteriaList01Types.PICKING_CRITERIA_LIST01_RESET_TIMESTAMP]: pickingCriteriaList01ResetTimestamp,
  [PickingCriteriaList01Types.PICKING_CRITERIA_LIST01_FETCH_PICKING_CRITERIA_LIST01_LOADING]: pickingCriteriaList01FetchPickingCriteriaList01Loading,
  [PickingCriteriaList01Types.PICKING_CRITERIA_LIST01_FETCH_PICKING_CRITERIA_LIST01_SUCCESS]: pickingCriteriaList01FetchPickingCriteriaList01Success,
  [PickingCriteriaList01Types.PICKING_CRITERIA_LIST01_ADD_SELECTED_DOCUMENTS]: pickingCriteriaList01AddSelectedDocuments,
  [PickingCriteriaList01Types.PICKING_CRITERIA_LIST01_REMOVE_SELECTED_DOCUMENTS]: pickingCriteriaList01RemoveSelectedDocuments,
  [PickingCriteriaList01Types.PICKING_CRITERIA_LIST01_SET_WORKSPACE_VISIBLE]: pickingCriteriaList01SetWorkspaceVisible
});
